import '../../../styles/ModalStyle/ModalStyle.css';

import { Checkbox, Col, Form, Input, Row } from 'antd';
import React, { Component } from 'react';

import FormInputTextMaterial from '../../../materials/FormInputTextMaterial';
import TextArea from 'antd/lib/input/TextArea';
import SelectField from 'components/SelectField';

interface IProps {
  GroupNameBranch: any;
  NameBranch: any;
  Province: any;
  City: any;
  SubDistrict: any;
  AreaCode: any;
  PhoneNumber: any;
  Village: any;
  PostalCode: any;
  Address: any;
  AdminBranch: any;
  Latitude: any;
  Longitude: any;
  Partner: any;
  RadiusValue: any;
  TypeAbsensi: any;
  GetRadiusChecked: any;
}

export default class FormDetailBranchComponent extends Component<IProps> {
  render() {
    const valueGroupNameBranch = this.props.GroupNameBranch === null || this.props.GroupNameBranch === 0 ? '-' : this.props.GroupNameBranch
    return (
      <div>
        <Row>
          <Col span={12}>
            <div className={'marginRightFormDetailbranch'}>
              <Form>
                <div className="padding-top-form-input">
                  <span>
                    <b>Nama HUB</b>
                  </span>
                  <FormInputTextMaterial
                    onPressEnter={''}
                    validateType={false}
                    value={this.props.NameBranch}
                    className={'inputFormBranch'}
                    disabled={false}
                    addonBefore={''}
                    placeholder={''}
                    prefix={''}
                    maxLength={''}
                    style={{}}
                    size=""
                    type={''}
                    onChange={''}
                    onBlur={''}
                    validatestatus={''}
                    help={''}
                  />
                </div>

                <div className="padding-top-form-input">
                  <span>
                    <b>Provinsi</b>
                  </span>
                  <FormInputTextMaterial
                    onPressEnter={''}
                    validateType={false}
                    value={this.props.Province}
                    className={'inputFormBranch'}
                    disabled={false}
                    addonBefore={''}
                    placeholder={''}
                    prefix={''}
                    maxLength={''}
                    style={{}}
                    size=""
                    type={''}
                    onChange={''}
                    onBlur={''}
                    validatestatus={''}
                    help={''}
                  />
                </div>

                <div className="padding-top-form-input">
                  <span>
                    <b>Kabupaten / Kota</b>
                  </span>
                  <FormInputTextMaterial
                    onPressEnter={''}
                    validateType={false}
                    value={this.props.City}
                    className={'inputFormBranch'}
                    disabled={false}
                    addonBefore={''}
                    placeholder={''}
                    prefix={''}
                    maxLength={''}
                    style={{}}
                    size=""
                    type={''}
                    onChange={''}
                    onBlur={''}
                    validatestatus={''}
                    help={''}
                  />
                </div>

                <div className="padding-top-form-input">
                  <span>
                    <b>Kecamatan</b>
                  </span>
                  <FormInputTextMaterial
                    onPressEnter={''}
                    validateType={false}
                    value={this.props.SubDistrict}
                    className={'inputFormBranch'}
                    disabled={false}
                    addonBefore={''}
                    placeholder={''}
                    prefix={''}
                    maxLength={''}
                    style={{}}
                    size=""
                    type={''}
                    onChange={''}
                    onBlur={''}
                    validatestatus={''}
                    help={''}
                  />
                </div>
                <div className="padding-top-form-input">
                  <span>
                    <b>Desa / Kelurahan</b>
                  </span>
                  <FormInputTextMaterial
                    onPressEnter={''}
                    validateType={false}
                    value={this.props.Village}
                    className={'inputFormBranch'}
                    disabled={false}
                    addonBefore={''}
                    placeholder={''}
                    prefix={''}
                    maxLength={''}
                    style={{}}
                    size=""
                    type={''}
                    onChange={''}
                    onBlur={''}
                    validatestatus={''}
                    help={''}
                  />
                </div>
                <div className={'marginRightFormDetailbranch'}>
                  <span>
                    <b>Rekanan</b>
                  </span>
                  <div className={'checkboxDetailBranch'}>
                    <Checkbox checked={this.props.Partner} />
                    <span className={'titleCheckboxDetailBranch'}>Pilih rekanan</span>
                  </div>
                </div>
                <div className="padding-top-form-input">
                  <span>
                    <b>Grup HUB</b>
                  </span>
                  <FormInputTextMaterial
                    onPressEnter={''}
                    validateType={false}
                    value={valueGroupNameBranch}
                    className={'inputFormBranch'}
                    disabled={false}
                    addonBefore={''}
                    placeholder={''}
                    prefix={''}
                    maxLength={''}
                    style={{}}
                    size=""
                    type={''}
                    onChange={''}
                    onBlur={''}
                    validatestatus={''}
                    help={''}
                  />
                </div>
              </Form>
            </div>
          </Col>

          <Col span={12}>
            <div className={'marginRightFormDetailbranch'}>
              <Form>
                <div className="padding-top-form-input">
                  <span>
                    <b>Kode Wilayah</b>
                  </span>
                  <FormInputTextMaterial
                    onPressEnter={''}
                    validateType={false}
                    value={this.props.AreaCode}
                    className={'inputFormBranch'}
                    disabled={false}
                    addonBefore={''}
                    placeholder={''}
                    prefix={''}
                    maxLength={''}
                    style={{}}
                    size=""
                    type={''}
                    onChange={''}
                    onBlur={''}
                    validatestatus={''}
                    help={''}
                  />
                </div>

                <div className="padding-top-form-input">
                  <span>
                    <b>No Telp </b>
                  </span>
                  <FormInputTextMaterial
                    onPressEnter={''}
                    validateType={false}
                    value={this.props.PhoneNumber}
                    className={'inputFormBranch'}
                    disabled={false}
                    addonBefore={'+62'}
                    placeholder={''}
                    prefix={''}
                    maxLength={''}
                    style={{}}
                    size=""
                    type={''}
                    onChange={''}
                    onBlur={''}
                    validatestatus={''}
                    help={''}
                  />
                </div>
                <div className="padding-top-form-input">
                  <span>
                    <b>Kode pos</b>
                  </span>
                  <FormInputTextMaterial
                    onPressEnter={''}
                    validateType={false}
                    value={this.props.PostalCode}
                    className={'inputFormBranch'}
                    disabled={false}
                    addonBefore={''}
                    placeholder={''}
                    prefix={''}
                    maxLength={''}
                    style={{}}
                    size=""
                    type={''}
                    onChange={''}
                    onBlur={''}
                    validatestatus={''}
                    help={''}
                  />
                </div>
                <div className="padding-top-form-input">
                  <span>
                    <b>Admin HUB</b>
                  </span>
                  <FormInputTextMaterial
                    onPressEnter={''}
                    validateType={false}
                    value={this.props.AdminBranch}
                    className={'inputFormBranch'}
                    disabled={false}
                    addonBefore={''}
                    placeholder={''}
                    prefix={''}
                    maxLength={''}
                    style={{}}
                    size=""
                    type={''}
                    onChange={''}
                    onBlur={''}
                    validatestatus={''}
                    help={''}
                  />
                </div>
                <div className="padding-top-form-input">
                  <span>
                    <b>Lokasi HUB</b>
                  </span>
                  <div style={{ paddingTop: 10 }}>
                    <span className={'poskoLocation'}>
                      {this.props.Latitude === null ||
                        this.props.Longitude === null
                        ? '- , -'
                        : `${this.props.Latitude}, ${this.props.Longitude}`}
                    </span>
                  </div>
                </div>
                <div className="padding-top-form-input">
                  <span>
                    <b>Alamat lengkap</b>
                  </span>
                  <TextArea
                    className={'formAddressBranch'}
                    value={this.props.Address}
                  ></TextArea>
                </div>
                <div>
                  <span>
                    <b>Zonasi</b>
                  </span>

                  <div style={{ paddingTop: "9px" }}>
                    <Checkbox
                      checked={this.props.GetRadiusChecked}
                      disabled
                    />
                    <span style={{ paddingLeft: 10 }}>Radius Lokasi Pengiriman</span>
                  </div>

                  {this.props.GetRadiusChecked && (
                    <>
                      <div style={{ marginLeft: 28, marginBottom: 10 }}>
                        <span style={{ fontStyle: "italic" }}>
                          Jangkauan Radius wajib diisi.
                        </span>
                      </div>

                      {/* Input angka + label Meter */}
                      <div
                        style={{
                          marginLeft: 28,
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          marginBottom: 16,
                        }}
                      >
                        <span style={{ width: 56 }}>Radius</span>
                        <Input
                          type="number"
                          min={1}
                          value={this.props.RadiusValue ?? ""}
                          style={{ width: 120, textAlign: "right" }}
                          readOnly
                        />
                        <span>Meter</span>
                      </div>

                      <div style={{ marginLeft: 28 }}>
                        <span style={{ fontWeight: "bold" }}>Pilih Jenis Absensi</span>
                        <div style={{ paddingTop: 9 }}>
                          <SelectField
                            style={{ fontWeight: "bold", color: "#000!important" }}
                            placeholder="Pilih jenis"
                            mode="multiple"
                            data={[
                              { id: 0, name: "Pilih Semua" },
                              { id: 1, name: "Masuk" },
                              { id: 2, name: "Pulang" },
                            ]}
                            value={this.props.TypeAbsensi ?? []}
                            disabled
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
